// components/qualificacao/SeloQualificacao.js — a pílula da marcação do lead
// (out/26, rastreamento PR 2). Lista do CRM, janela do contato e topo do
// chat usam a mesma. `compacto` = só o ícone, sempre (linha da lista do
// CRM: com o selo "Anúncio" ao lado, o texto empurrava a célula do nome pra
// cima da coluna do número); `compactoAbaixo` = só o ícone abaixo de X px.
// A frase inteira fica no title e no aria-label.

import { Box } from '@mui/material';
import { FiCheck, FiDollarSign, FiSlash } from 'react-icons/fi';
import { STATUS, descrever } from './regras';

const ICONE = { qualificado: FiCheck, desqualificado: FiSlash, venda: FiDollarSign };

export default function SeloQualificacao({ qualificacao, status, compacto = false, compactoAbaixo, alto = 20, comDetalhe = false }) {
  const st = qualificacao?.status || status;
  const t = STATUS[st];
  if (!t) return null;
  const Icone = ICONE[st];
  const frase = qualificacao ? descrever(qualificacao) : t.rotulo;
  return (
    <Box component="span" title={frase} aria-label={frase} sx={{
      flexShrink: 0, height: alto, px: '7px', gap: '4px', borderRadius: '999px', display: 'inline-flex', alignItems: 'center',
      bgcolor: t.bg, color: t.cor, border: `1px solid ${t.borda}`, maxWidth: '100%', minWidth: 0,
      fontFamily: "'Outfit', system-ui, sans-serif", fontSize: alto > 20 ? 12.5 : 11.5, fontWeight: 600, whiteSpace: 'nowrap',
      ...(compacto ? { width: alto, px: 0, justifyContent: 'center', '& .sq-texto': { display: 'none' } } : {}),
      ...(compactoAbaixo ? { [`@media (max-width: ${compactoAbaixo - 0.02}px)`]: { px: '5px', '& .sq-texto': { display: 'none' } } } : {}),
    }}>
      <Icone size={alto > 20 ? 12 : 11} strokeWidth={2.6} aria-hidden style={{ flexShrink: 0 }} />
      <Box component="span" className="sq-texto" aria-hidden sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {comDetalhe ? frase : t.curto}
      </Box>
    </Box>
  );
}
